export const PAYMENT_BUTTON_COMPONENTS = [
  "initial",
  "newButtonForm",
  "newPaymentButton",
];
